import React, { useEffect, useState, useRef, useMemo } from "react";
import { cl } from "../../../utilities/cl";
import { isFunc } from "../../../utilities/isFunc";
import SvgArrowDownLight from "../../SVG/ArrowDownLight";
import InputText from "../InputText";
import Time from "./Time";
import MobileModal from "../../MobileModal";

const CycleTime = ({
  className = "",
  label,
  comment,
  name,
  value = "",
  times = [
    { title: "Часы", from: 0, to: 23, step: 1 },
    { title: "Минуты", from: 0, to: 55, step: 5 },
  ],
  placeholder = "ЧЧ, ММ",
  divider = ":",
  isTime = true,
  onChange,
  disabled,
  allowZeroValue = true,
}) => {
  const split = (val) => splitStringToNumbers(val, divider);

  const [val, setVal] = useState(value || "");
  const [arrayVals, setArrayVals] = useState(split(value));
  const [opened, setOpened] = useState(false);

  // 💾 сохраняем начальное значение только один раз
  const [initialValue] = useState(value || "");
  const [initialArrayVals] = useState(split(value));

  const refCycleTime = useRef(null);
  const refCycleTimeContent = useRef(null);

  useEffect(() => {
    setVal(value || "");
    setArrayVals(split(value));
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!opened) return;
      const container = refCycleTime.current;
      const content = refCycleTimeContent.current;
      if (
        container &&
        !container.contains(e.target) &&
        (!content || !content.contains(e.target))
      ) {
        setOpened(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [opened]);

  const hOpen = () => !disabled && setOpened(true);
  const hClose = () => setOpened(false);

  const hChangeArrayVal = ({ val, index }) => {
    const nextArrayVals = [...arrayVals];
    nextArrayVals[index] = val;
    setArrayVals(nextArrayVals);
  };

  const hApply = (customVals) => {
    const vals = Array.isArray(customVals) ? customVals : arrayVals;
    const nextVal = normalizeTimeValue(buildStrValue(vals, divider, isTime));
    const isZero = nextVal === `00${divider}00`;

    // 🟢 если allowZeroValue разрешён, сохраняем "00:00"
    // 🔴 если нет — очищаем
    const finalVal = !allowZeroValue && isZero ? "" : nextVal;
    console.log({ allowZeroValue, finalVal });


    setVal(finalVal);
    hClose();
    console.log({vals});
    
    if (isFunc(onChange)) {
      onChange({
        name,
        value: !isTime ? (vals[0] || null) : finalVal || null,
      });
    }
  };


  const hReset = () => {
    setVal("");
    setArrayVals([0, 0]);
    if (isFunc(onChange)) onChange({ name, value: null });
    hClose();
  };


  const hasChanged =
    buildStrValue(arrayVals, divider, isTime) !==
    buildStrValue(initialArrayVals, divider, isTime);

  className = cl(className, "FormCycleTime", { opened, disabled });
  const contentClassName = cl("FormCycleTime__content", { opened });

  return (
    <div ref={refCycleTime} className={className}>
      <InputText
        className="FormCycleTime__input"
        label={label}
        comment={comment}
        icon={<SvgArrowDownLight title="Развернуть список" size="mr2" />}
        attrs={{
          value: getVisibleValue() ?? "",
          placeholder,
          readOnly: true,
        }}
        onClick={hOpen}
        disabled={disabled}
      />

      <MobileModal opened={opened}>
        <div ref={refCycleTimeContent} className={contentClassName}>
          <div className="FormCycleTime__times">
            {times.map((time, index) => (
              <Time
                key={index}
                index={index}
                value={arrayVals[index]}
                isTime={isTime}
                onChange={hChangeArrayVal}
                title={time.title}
                from={time.from}
                to={time.to}
                step={time.step}
              />
            ))}
          </div>

          <div className="FormCycleTime__buttons MobileModal__buttons">
            {/* {hasChanged ? (
              <div className="save" onClick={hReset}>
                Сбросить
              </div>
            ) : (
              <div className="cancel" onClick={hClose}>
                Отменить
              </div>
            )} */}
            <div className="save" onClick={hReset}>
              Сбросить
            </div>

            <div className="save" onClick={hApply}>
              Сохранить
            </div>
          </div>
        </div>
      </MobileModal>
    </div>
  );

  function getVisibleValue() {
    if (!val) return null;
    const localVal = String(val ?? "");

    // если allowZeroValue запрещает 00:00 — показываем placeholder
    if (!allowZeroValue && localVal === `00${divider}00`) return null;

    // иначе — показываем даже 00:00
    const vals = localVal.split(divider);
    if (!vals[1]) vals[1] = "00";
    return vals.filter((v, i) => times[i] !== undefined).join(divider);
  }


};

export default CycleTime;

//
// utils
//
function splitStringToNumbers(str = "", divider) {
  const arr = String(str ?? "").split(divider);
  return arr.map((s) => Number(s) || 0);
}

function buildStrValue(vals = [], divider, isTime) {
  return vals
    .map((val) => {
      val = val.toString();
      if (val.length === 1 && isTime === true) val = `0${val}`;
      return val;
    })
    .join(divider);
}

function normalizeTimeValue(value = "", divider = ":") {
  if (!value) return "";
  const parts = value.split(divider).map((v) => v.trim());
  const hours = parts[0] ? parts[0].padStart(2, "0") : "00";
  const minutes = parts[1] ? parts[1].padStart(2, "0") : "00";
  return `${hours}${divider}${minutes}`;
}
